module.exports = __webpack_public_path__ + "static/media/std.1b268ead.jpg";